import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import FontStyle from "../styles/fonts/fonts.css"

import "./layout.css"
import Header from "./Header/index"
import Content from "./Content"
import Parrafo from "./Parrafo"
import Quote from "./Quote"
import Image from "./Image"
import theme from "../styles/theme.css"
import Video from "./Video"
import ilustration from "../images/Especial_ilus_01.png"
import ilustration2 from "../images/Especial_ilus_02.png"
import imagen_01 from "../images/imagen_01.jpg"
import imagen_02 from "../images/imagen_02.jpg"
import imagen_03 from "../images/imagen_03.jpg"
import imagen_04 from "../images/imagen_04.jpg"
import imagen_05 from "../images/imagen_05.jpg"
import imagen_06 from "../images/imagen_06.jpg"
import imagen_07 from "../images/imagen_07.jpg"
import imagen_08 from "../images/imagen_08.jpg"
import reproducir from "../assets/boton-de-reproduccion-de-video.svg"
import Note from "./Note"
import Footer from "./Footer"
import Share from "./Sharer"
import VideoGallery from "./VideoGallery"
import Helmet from "react-helmet"
import HeaderSticky from "./HeaderSticky"
import More from "./More"
import share from "../images/share.jpg"

const Layout = ({
  lang = "en",
  title = "Andar Juntas: Un manifiesto skater",
  meta = [],
  description = ``,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            domain
            url
            fbappid
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <React.Fragment>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={title}
        titleTemplate={`%s | Laboratorio de Contenidos de Marca de La Tercera`}
        meta={[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:image`,
            content: `${site.siteMetadata.domain}${share}`,
          },
          {
            property: `og:url`,
            content: `${site.siteMetadata.url}/`,
          },
          {
            property: `fb:app_id`,
            content: `${site.siteMetadata.fbappid}`,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata.author,
          },
          {
            name: `twitter:title`,
            content: title,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
        ].concat(meta)}
      />
      <Header />
      <FontStyle />

      <HeaderSticky />

      <Content bgColor={theme.yellow}>
        <Parrafo texto="Todos los miércoles en la tarde se repite la misma escena. Al skatepark del Parque Araucano, en Las Condes, llegan niñas de todas las edades. O llegaban. Por la pandemia llevan varios meses lejos del bowl, las escaleras y las barandas que las reunía aún cuando viven en polos opuestos de Santiago. Este es un obstáculo más. Se han caído una y mil veces para derribar prejuicios. Pero lo que las une es más fuerte: el skate." />
        <h1
          style={{
            marginTop: "2rem",
            marginBottom: "2rem",
            textAlign: "center",
            paddingTop: "8rem",
          }}
          data-sal="slide-up"
          data-sal-delay="2000"
          data-sal-easing="ease"
          id="parte1"
        >
          PARTE I: arriba y abajo de la tabla
        </h1>
        <Parrafo texto="Matilde, Francisca, Antonia y Martina saben que ser auténticas va más allá del género y significa romper barreras. Una de ellas es ser mujer, ¿cómo lo viven?" />
        <Share
          socialConfig={{
            twitterHandle: "latercera",
            config: {
              url: `https://especiales.latercera.com/andar-juntas/?utm_source=share&utm_medium=latercera#parte1`,
              title: `${title} - PARTE I: arriba y abajo de la tabla`,
              hashtags: ["andarjuntas"],
            },
          }}
          data-sal="slide-up"
          data-sal-delay="2000"
          data-sal-easing="ease"
        />
        <Video url="https://www.youtube.com/embed/OeVnFkXOplk" />

        <Quote
          name="Matilde"
          cita="En la actualidad ser mujer es luchar más allá. Salir adelante cómo sea, en lo que sea. Dentro o fuera del skate. Pero en todo siempre es mejor hacerlo juntas. Siempre juntas, todas"
        />
        <Image url={imagen_01} name="Matilde, 15 años, Vitacura." />
        <Quote
          name="Francisca"
          cita="A mí me molestaba mucho el hecho de ser mujer. Siempre pensaba que por qué yo no podía hacer ciertas cosas, pero los hombres sí. ¿Por qué yo no puedo salir de tal manera vestida a la calle y ellos sí pueden? Me molestaba mucho eso, pero uno se va empoderando. Siento que de a poco a las mujeres, más que considerarlas como mujeres, se les considera personas, igual que todos"
        />
        <Image url={imagen_02} name="Francisca, 16 años, Puente Alto." />
        <Quote
          name="Antonia"
          cita="Creo que ser mujer a veces es muy difícil. Uno tiene que tener mucho cuidado, siempre estar atenta a la persona que tenís al lado porque nunca sabes cuando te va a pasar algo malo. Pero hoy hay muchas mujeres que están ayudando a la mujer que tienen al lado, aunque no la conozcan, porque saben que es difícil salir a la calle a veces, sola en las noches. Espero, sinceramente, que Chile tenga una evolución mucho más grande y que uno pueda salir sin miedo"
        />
        <Image url={imagen_03} name="Antonia, 15 años, San José de Maipo." />
        <Quote
          name="Martina"
          cita="Antes la mujer estaba más debilitada porque había más machismo. Como que el centro del mundo eran los hombres. Las mujeres en mi familia son fuertes porque nunca hubo un hombre que nos protegiera"
        />
        <Image url={imagen_04} name="Martina, 15 años, Puente Alto." />
      </Content>

      <Content bgColor={theme.new}>
        <h3
          data-sal="fade"
          data-sal-delay="2000"
          data-sal-easing="ease"
          style={{
            marginTop: "1rem",
            marginBottom: "2rem",
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          LEJOS DEL SKATEPARK
        </h3>
        <Parrafo texto="Ha pasado casi un año desde que comenzó la pandemia. Eso, entre muchas cosas, ha significado que las skaters no se reúnan más. Pero estar lejos del skatepark no es sinónimo de estar lejos del skate." />
        <iframe
          data-sal="fade"
          data-sal-delay="2000"
          data-sal-easing="ease"
          id="vrudo"
          className="vrudo-1"
          src="https://rudo.video/vod/bJv4tq?autoplay=1&volume=0&loop=1&stv=0"
          allowscriptaccess="always"
          allowFullScreen={true}
          webkitallowfullscreen="true"
          frameBorder="0"
          scrolling="no"
          allow="autoplay"
        />
        <span className="bajada-video">
          Antonia se graba deslizándose en una baranda que instaló en su pieza
          ahora que no puede ir al skatepark.
        </span>
        <Quote
          name="Antonia"
          cita="En San José de Maipo es mucho más campo. Decidí poner una baranda en mi pieza, pero es complicado porque termino mis tareas muy tarde, entonces estoy patinando como a las 10 PM. Siento que soy muy afortunada de tener un lugar para poder practicar, aunque sea cinco minutos. Pero es difícil no estar en el parque y no progresar. Es complicado no ver a mis amigas, pero por lo menos existen las videollamadas. Me siento un poco angustiada, pero estamos velando por la seguridad de cada persona. Este virus es muy peligroso"
        />
        <Quote
          name="Francisca"
          cita="Lo único que quiero es salir, aunque sea solamente a andar. En mi pieza pongo una alfombra o una toalla bajo la tabla y practico los raspados. Me da miedo perder el progreso que llevo por no tener espacio donde practicar. Ahora intento hablarle a mis amigos, decirles que cuando pase todo esto salgamos a patinar"
        />
        <Quote
          name="Martina"
          cita="Es demasiado difícil estar tanto tiempo sin patinar. Tengo un patio, pero el piso es muy malo, entonces si patino me caería todo el rato. Últimamente había progresado harto y cuando vuelva va a ser como empezar de nuevo"
        />
      </Content>

      <Content bgColor={theme.lightBlue}>
        <h3
          data-sal="fade"
          data-sal-delay="2000"
          data-sal-easing="ease"
          style={{
            marginTop: "2rem",
            marginBottom: "2rem",
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          derribando prejuicios
        </h3>
        <Note
          span="(Informe GFK, Onu Mujeres)"
          texto="Las niñas y niños se dan cuenta que la sociedad hace diferencias entre ellos respecto a su relación con el deporte. 21% cree que a las niñas se les discrimina por considerarlas menos capaces realizando algún deporte. 50% cree que a los niños se les considera bacanes cuando hacen deporte y a ellas no. Un 48% de ellas cree que se premia más a los hombres deportistas.
          "
        />
        <Quote
          name="Antonia"
          cita="Mucha gente piensa que el skate es solo droga y fumar. No es así. A mí el skate me ayudó a ser mejor persona. Quizás tengo una madurez mucho más grande gracias al skate porque te enseña valores y eso lo aplicas diariamente a tu vida"
        />
        <Quote
          name="Matilde"
          cita="Partí por mi hermano que patinaba. Él me traía a escondidas porque mi papá no me dejaba, encontraba que era un deporte para hombres"
        />
        <Quote
          name="Catalina"
          cita="A mí me ha pasado como tres veces que ando con mi hermana y nos hemos tenido que ir de tiendas. Una vez andaba con mi prima y nos preguntaron que qué teníamos en la mochila. No teníamos nada, pero nos tuvimos que ir porque nos estaban persiguiendo"
        />
        <Quote
          name="Antonia"
          cita="Muchas personas te dicen ‘¿por qué no te vestís como señorita si erís mujer?’. Te juzgan porque tu polera es más larga y ahí altiro te dicen ‘erís muy machito para tus cosas’. Uno sigue siendo mujer pese a todo"
        />
      </Content>

      <Content bgColor={theme.red}>
        <Image url={ilustration} />
        <h3
          data-sal="slide-up"
          data-sal-delay="2000"
          data-sal-easing="ease"
          style={{
            marginTop: "2rem",
            marginBottom: "2rem",
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          skate, más allá de las clases
        </h3>
        <Note
          span="(Salud Urbana en América Latina (SALURBAL) publicada en The Lancet Planetary Health)."
          texto="Santiago es una de las ciudades con un mayor contraste entre distintos territorios. La brecha en la esperanza de vida entre las diferentes comunas de la ciudad es de casi 18 años para las mujeres. La mayor esperanza de vida al nacer está en las comunas del nororiente de la ciudad."
        />
        <Parrafo texto="Francisca siempre ha querido pertenecer a un grupo. Dice que en el colegio no ha sido fácil. En el skate encontró a lo que, en ese mundo, llaman crew. Una comunidad por la que viaja de Puente Alto a Las Condes, donde se encuentra con otras adolescentes como ella. Conoce su historia en el siguiente video."></Parrafo>

        <h3
          id="parte2"
          data-sal="fade"
          data-sal-delay="2000"
          data-sal-easing="ease"
          style={{
            paddingTop: "8rem",
            marginTop: "2rem",
            marginBottom: "2rem",
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          Parte II: La Crew
        </h3>
        <Share
          socialConfig={{
            twitterHandle: "latercera",
            config: {
              url: `https://especiales.latercera.com/andar-juntas/?utm_source=share&utm_medium=latercera#parte2`,
              title: `${title} - PARTE II: La Crew`,
              hashtags: ["andarjuntas"],
            },
          }}
          data-sal="slide-up"
          data-sal-delay="2000"
          data-sal-easing="ease"
        />
        <Video url="https://www.youtube.com/embed/FD5ATzB_jmg" />
        <Quote
          name="Francisca"
          cita="Al principio yo no conocía otros skatepark que no fuera el de Puente Alto. Llegué acá (al de Las Condes) con miedo igual. Pensaba ‘pucha, ¿me vendrán a decir algo por venir de allá? ¿será todo muy distinto? ¿me mirarán de pies a cabeza?’. Fue todo lo contrario. Incluso me hablaban como si me conocieran de toda la vida. Te veían complicada con un truco y te decían: ‘No, si esto se hace así. Yo te ayudo’"
        />
        <Quote
          name="Antonia"
          cita="Yo soy de San José de Maipo y viajo casi dos horas para llegar a este skatepark (Las Condes). Uno piensa: 'no, ella tiene amistades muy distintas a las mías'. Quizás venimos de comunas distintas, tenemos cosas que quizás la otra no tiene, pero finalmente uno conoce a la persona y te das cuenta que da igual el estatus social. Al final tu amiga te va a apoyar sea de donde sea. El skate es así, porque todos tienen el mismo amor por la tabla"
        />
        <Image
          url={imagen_05}
          nota="Las clases de skate femenino del Parque Araucano se realizan todos los miércoles, desde las 18:00 horas. Los talleres son abiertos y gratuitos."
        />
        <Quote
          name="Matilde"
          cita="Pensé que iba a ser un grupo cerrado, como una burbuja. Creí que acá venía gente solo de los lugares más cercanos (a Las Condes). Pero hay personas de muchas comunas, que viven a dos horas de distancia de acá. Si yo veo a alguien que no tiene donde quedarse y es amigo mío, o quizás no es amigo mío, le digo: “si te sirve de algo estoy en mi casa, vivo cerca, te puedo dar comida o algo si te hace falta”, ¿cachai? Si yo veo que lo puedo ayudar, obviamente voy a tratar de ayudarlo"
        />
        <Quote
          name="Martina"
          cita="Es genial que vengamos de distintos lugares hacia un mismo lugar y que hagamos todas lo mismo"
        />
      </Content>

      <Content bgColor={theme.lile}>
        <Image url={ilustration2} />
        <h3
          data-sal="fade"
          data-sal-delay="2000"
          data-sal-easing="ease"
          style={{
            marginTop: "2rem",
            marginBottom: "2rem",
            textAlign: "center",
          }}
        >
          ANDAR JUNTAS
        </h3>
        <Note
          span="(Informe GFK, Onu Mujeres)."
          texto="La principal razón por la que las niñas abandonan el deporte y piensan que no es un espacio para ellas, es la falta de redes de apoyo y de espacios habilitados para que potencien sus capacidades deportivas."
        />
        <Parrafo texto="A Francisca, Matilde, Antonia y Martina muchas veces les han dicho que el skate no es para ellas. Pero han aprendido a hacer oídos sordos por el deporte que, dicen, las ha hecho crecer y aprender valiosas lecciones." />

        <h3
          id="parte3"
          data-sal="fade"
          data-sal-delay="2000"
          data-sal-easing="ease"
          style={{
            paddingTop: "8rem",
            marginTop: "2rem",
            marginBottom: "2rem",
            textAlign: "center",
          }}
        >
          PARTE III: UNIDAS 360°
        </h3>
        <Share
          socialConfig={{
            twitterHandle: "latercera",
            config: {
              url: `https://especiales.latercera.com/andar-juntas/?utm_source=share&utm_medium=latercera#parte3`,
              title: `${title} - PARTE III: Unidas 360°`,
              hashtags: ["andarjuntas"],
            },
          }}
          data-sal="slide-up"
          data-sal-delay="2000"
          data-sal-easing="ease"
        />
        <Video url="https://www.youtube.com/embed/VOPwo6H4Mrk" />
        <Quote
          name="Francisca"
          cita="Un día vi que se podía arrendar tablas (de skate) por una hora. Arrendé una y al principio no sabía qué hacer, pero justo había una niña patinando y le dije: ‘oye, ¿tú me podrías enseñar lo básico, como subirme?’. Estuvo toda la hora enseñándome y desde ahí que empecé a patinar en serio. Fue bonito. Aquí si un amigo lleva muy poco patinando y saca un ‘ollie’ lindo, o incluso si no sale tan bien, uno se emociona. Aunque no sea un truco que haya sacado uno"
        />
        <Quote
          name="Matilde"
          cita="Cuando uno está haciendo un truco y lo quiere tener es como ‘oh, me grabai este truco, por fa’. Y ahí tú vai, le decís: ‘Vamos, cáele, vamos, ahora sale’ y motivai a la otra persona para hacerlo. El compañerismo entre mujeres acá es bacán"
        />
        <Quote
          name="Antonia"
          cita="Yo conocí a mi mejor amiga durante el día del skate. Patinamos muchas cuadras y me ayudaba con la mano porque yo no tenía tanta fuerza para seguir patinando. Me ayudó a aprender nuevas técnicas y también a conocer a nuevas personas. Y como vivo tan lejos (en San José de Maipo), ella me invitó a quedarme en su casa (en Vitacura) para no viajar tantas horas. Tenemos una amistad súper linda"
        />
        <Quote
          name="Martina"
          cita="Era tímida cuando llegué. Pero las niñas me decían ‘¿te ayudo?’, me daban tips y cosas así. No fueron competitivas porque siempre me ayudaban y siempre se alegraban de mis logros. Y yo de los de ellas también. Cuando uno va con más mujeres como que ya no te pasa nada. Yo entro y a patinar, porque vamos con más fuerza"
        />
        <Image
          url={imagen_06}
          nota="De izquierda a derecha: Martina, Matilde, Antonia, Catalina y Francisca."
        />
        <Image
          url={imagen_07}
          nota="El ollie (en la foto) es el movimiento más básico y que abre caminos a los demás trucos arriba de la tabla. Al realizar un ollie, el patinador y la tabla saltan en el aire, permaneciendo en contacto durante el salto."
        />
      </Content>

      <Content bgColor={theme.green}>
        <h3
          data-sal="slide-up"
          data-sal-delay="2000"
          data-sal-easing="ease"
          style={{
            marginTop: "2rem",
            marginBottom: "2rem",
            textAlign: "center",
          }}
        >
          ABRIR ESPACIOS
        </h3>
        <Note
          span="(Fundación Vivienda)."
          texto="Si para llegar a las 8 de la mañana a, por ejemplo, metro Tobalaba desde Las Condes es necesario levantarse a las 6:30; para llegar al mismo punto desde Puente Alto, es necesario despertar a las 5:30."
        />
        <Quote
          name="Francisca"
          cita="Hay veces que me he sentido mal o no aceptada solo por el hecho de ser mujer. Al principio me sentí discriminada, porque tú miras alrededor y ves a 50 hombres y 10 mujeres. Cuando comencé a patinar iba con amigos míos del colegio, pero no fue una experiencia bonita. Iba con ellos a Tobalaba (donde hay un skatepark). Con uno de mis amigos queríamos sacar un truco. Pero a él le ofrecían más ayuda y atención. No sé si por el hecho de ser hombre. Incluso a mí me dejaban de lado. Me dio pena porque uno va con todas las ganas y que pasen estas cosas, que lo hagan tan notorio, da pena"
        />
        <Quote
          name="Matilde"
          cita="En el skate, al comienzo, es muy difícil decir ‘somos todos iguales’, porque al final no es así. O sea, es así para uno, pero cuesta llegar al punto en que tú le decís a los hombres: 'Cuidado, nosotras también estamos acá, dennos un espacio también’, ¿cachai? Pero uno va agarrando más confianza en el skate, se van dando los espacios. Al final somos todos una familia"
        />
        <Image
          url={imagen_08}
          nota="Aunque históricamente se ha ligado el skate a lo masculino, hoy incluso Chile cuenta con su primera selección femenina de skateboarding."
        />
        <h4
          data-sal="slide-up"
          data-sal-delay="2000"
          data-sal-easing="ease"
          style={{
            marginTop: "3rem",
            marginBottom: "2rem",
            textAlign: "left",
            marginLeft: "5px",
          }}
        >
          VER TODOS LOS VIDEOS
        </h4>

        <VideoGallery />
      </Content>

      <Content bgColor={theme.black}>
        <h4
          style={{
            marginTop: "3rem",
            marginBottom: "2rem",
            textAlign: "left",
            maxWidth: "940px",
            color: "#FFFFFF",
          }}
        >
          Conoce otros de nuestros proyectos:
        </h4>
        <More />
      </Content>
      <Footer />
    </React.Fragment>
  )
}

export default Layout
